import { useEffect, useMemo, useState } from "react";

import { useParams } from "react-router-dom";

import useMeetingReportSessionNotes from "@app/analytics/MeetingReport/hooks/useMeetingReportSessionNotes";
import useTranscript from "@app/analytics/MeetingReport/hooks/useTranscript";
import { generateTextFileFromSummary } from "@app/analytics/MeetingReport/utils";
import downloadFile from "@app/analytics/ReportFileDownload/downloadFile";
import ROUTES from "@app/common/routes";

import FileDownload from "./FileDownload";
import useMeetingDetails from "./useMeetingDetails";
import usePageTitle from "../../utils/hooks/usePageTitle";

const MeetingSummaryDownload = () => {
  usePageTitle("Summary Download");

  const { sessionId } = useParams();
  const [downloaded, setDownloaded] = useState(false);

  const { summary, isLoading: transcriptIsLoading } = useTranscript();
  const { notes, isInitialLoading: notesIsInitialLoading } =
    useMeetingReportSessionNotes();
  const {
    data: meetingDetails,
    isInitialLoading: meetingDetailsIsInitialLoading,
    isError: meetingDetailsIsError,
  } = useMeetingDetails(sessionId!);

  const loading =
    transcriptIsLoading ||
    notesIsInitialLoading ||
    meetingDetailsIsInitialLoading;

  const txtFile = useMemo(() => {
    if (loading) return "No summary available";

    return generateTextFileFromSummary(summary, notes, meetingDetails);
  }, [summary, meetingDetails.title, loading]);

  useEffect(() => {
    if (loading || downloaded) return;
    setDownloaded(true);
    downloadFile(txtFile, "summary", meetingDetails.title);
  }, [loading, downloaded, txtFile, meetingDetails.title]);

  return (
    <FileDownload
      title="summary"
      loading={loading}
      error={meetingDetailsIsError || (!loading && !summary)}
      reportUrl={ROUTES.meetingReportById(sessionId!)}
    />
  );
};

export default MeetingSummaryDownload;
